import * as React from 'react';
import { Chip, Paper, Typography } from '@mui/material';
import {
  Review,
  SeoItem,
  VERDICT_COLOR,
  VERDICT_LABEL,
  Verdict,
} from '../types';

// "2026-10-20" -> "Oct 20, 2026" (UTC, so a date never shifts by a day).
export function formatDay(isoDate: string) {
  const [y, m, d] = isoDate.slice(0, 10).split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });
}

export function formatTime(iso: string) {
  return new Date(iso).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export const fmt = (n: number | null | undefined) =>
  n === null || n === undefined ? '—' : n.toLocaleString('en-US');

export function Section({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}) {
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="subtitle2">{title}</Typography>
      {subtitle && (
        <Typography variant="caption" color="text.secondary" display="block">
          {subtitle}
        </Typography>
      )}
      <div style={{ marginTop: 8 }}>{children}</div>
    </Paper>
  );
}

export function VerdictChip({ verdict }: { verdict?: Verdict | null }) {
  if (!verdict) return null;
  return (
    <Chip
      size="small"
      color={VERDICT_COLOR[verdict]}
      label={VERDICT_LABEL[verdict]}
    />
  );
}

// The latest verdict-day review that has been measured (day 56 over day 28).
export function latestVerdict(item: SeoItem): Verdict | null {
  const judged = item.reviews.filter(
    r => r.status === 'done' && r.day >= 28 && r.verdict,
  );
  return judged.length ? (judged[judged.length - 1].verdict ?? null) : null;
}

export function nextReview(item: SeoItem): Review | null {
  return item.reviews.find(r => r.status === 'scheduled') ?? null;
}
